import React from 'react';
import style from './Error.module.css';
import logo from "../../../assets/images/logo.png";

function Error({code = 404, title = "Сторінка не знайдена"}) {
    return (
        <div className={style.error} style={{
            /*background: `url(${bgImage})`,*/
            backgroundColor: 'var(--main-first)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            <div className={style.errorWrapper}>
              <img src={logo} className={style.errorLogo} alt="logo"/>
                <h2>404</h2>
                <p>{title}</p>
                <nav className={style.errorNav}>
                    <ul>
                        <li>
                            <a href={'/'} onClick={(e) => {
                                e.preventDefault();
                                window.history.back();
                            }}>
                                {'Назад'}
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default Error;
